import React from 'react';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { ImageSlot } from '../components/ui/ImageSlot';
import { blogPosts } from '../data/blog';
import { IMAGES } from '../data/images';
export function Blog() {
  const [lead, ...rest] = blogPosts;
  return <>
      <Seo title="Blog — Training Tips & Nevada CCW Info" description="Training tips, Nevada CCW guidance and women’s defense articles from the HPP Training instructors in Las Vegas." data-id="element-620" data-mp="36y6urc618y5" />
      <PageHero title="Training Notes" sub="Practical guidance from our instructors on carry, the law and defensive skill." image={IMAGES.lowlight} crumbs={[{
      label: 'Blog'
    }]} data-id="element-621" data-mp="cy16dopg5fvb" />
      <section className="gutter section bg-white" aria-label="Articles" data-id="element-622" data-mp="3gmmacyn5ipuz">
        <Link to={`/blog/${lead.slug}`} className="group grid gap-8 lg:grid-cols-2 lg:items-center" data-id="element-623" data-mp="3gkjbrq7xnoen">
          <ImageSlot image={lead.image} className="aspect-[16/10] rounded-[4px]" imgClassName="transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-624" data-mp="3blf4x68he2rh" />
          <div data-id="element-625" data-mp="273f4w72kp234">
            <p className="text-sm font-semibold uppercase tracking-[0.12em] text-accent" data-id="element-626" data-mp="2735nh7vlg391">{lead.category}</p>
            <h2 className="t-h2 mt-3 text-navy group-hover:underline group-hover:decoration-accent group-hover:underline-offset-8" data-id="element-627" data-mp="2bvp0a2mgiucs">{lead.title}</h2>
            <p className="t-lead mt-5 max-w-[42rem] text-steel" data-id="element-628" data-mp="1j6rli9hgffos">{lead.excerpt}</p>
            <p className="mt-5 text-sm text-steel" data-id="element-629" data-mp="1o5l0658h9cqj">
              {format(parseISO(lead.date), 'MMMM d, yyyy')} · {lead.readTime}
            </p>
          </div>
        </Link>
        <ul className="mt-16 grid gap-x-6 gap-y-12 border-t border-navy/15 pt-12 sm:grid-cols-2 xl:grid-cols-3 3xl:grid-cols-5" data-id="element-630" data-mp="1s5v5rgscy14v">
          {rest.map(p => <li key={p.slug} data-id="element-631" data-mp="33n4qe6n82z7r">
              <Link to={`/blog/${p.slug}`} className="group flex h-full flex-col" data-id="element-632" data-mp="33m3bfr335skr">
                <ImageSlot image={p.image} className="aspect-[16/10] rounded-[4px]" imgClassName="transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-633" data-mp="38k4sk6gybhtl" />
                <p className="mt-5 text-xs font-semibold uppercase tracking-[0.12em] text-accent" data-id="element-634" data-mp="14hv3cvz3f02j">{p.category}</p>
                <h3 className="t-h3 mt-2 text-navy group-hover:underline group-hover:decoration-accent group-hover:underline-offset-4" data-id="element-635" data-mp="1ihmf0q2504dd">{p.title}</h3>
                <p className="mt-2 text-steel" data-id="element-636" data-mp="1dg6t6vs4xttx">{p.excerpt}</p>
                <p className="mt-auto pt-4 text-sm text-steel" data-id="element-637" data-mp="ptqj3nke6ghn">
                  {format(parseISO(p.date), 'MMM d, yyyy')} · {p.readTime}
                </p>
              </Link>
            </li>)}
        </ul>
      </section>
    </>;
}